// const stripHtml = (value = "") => {
//   const element = document.createElement("div");
//   element.innerHTML = value;

//   return element.textContent || element.innerText || "";
// };

// const getFeaturedImage = (post) => {
//   const media = post?._embedded?.["wp:featuredmedia"]?.[0];

//   return {
//     src:
//       media?.media_details?.sizes?.large?.source_url ||
//       media?.media_details?.sizes?.medium_large?.source_url ||
//       media?.source_url ||
//       null,
//     alt: media?.alt_text || stripHtml(post?.title?.rendered) || "",
//   };
// };

// export const mapWordPressPostToAnnouncement = (post) => {
//   const image = getFeaturedImage(post);

//   return {
//     id: post.id,
//     title: stripHtml(post.title?.rendered),
//     excerpt: stripHtml(post.excerpt?.rendered),
//     publishedAt: post.date,
//     url: post.link,
//     image,
//     source: "wordpress",
//   };
// };


const stripHtml = (value = "") => {
  const element = document.createElement("div");
  element.innerHTML = value;

  return element.textContent || element.innerText || "";
};


const getFeaturedImage = (post) => {
  const media = post?._embedded?.["wp:featuredmedia"]?.[0];

  return {
    src:
      media?.media_details?.sizes?.large?.source_url ||
      media?.media_details?.sizes?.medium_large?.source_url ||
      media?.source_url ||
      null,

    alt:
      media?.alt_text ||
      stripHtml(post?.title?.rendered) ||
      "",
  };
};


export const mapWordPressPostToAnnouncement = (post) => {
  const image = getFeaturedImage(post);

  return {
    id: post.id,

    title:
      stripHtml(post.title?.rendered),

    excerpt:
      stripHtml(post.excerpt?.rendered),

    content:
      post.content?.rendered || "",

    publishedAt:
      post.date,

    url:
      post.link,

    image,

    source: "wordpress",
  };
};